/* eslint-disable no-unused-vars */
export enum ELSA_ROLE {
  ErikoistuvaLaakari = 'ROLE_ERIKOISTUVA_LAAKARI',
  YEKKoulutettava = 'ROLE_YEK_KOULUTETTAVA',
  Kouluttaja = 'ROLE_KOULUTTAJA',
  OpintohallinnonVirkailija = 'ROLE_OPINTOHALLINNON_VIRKAILIJA',
  TekninenPaakayttaja = 'ROLE_TEKNINEN_PAAKAYTTAJA',
  Vastuuhenkilo = 'ROLE_VASTUUHENKILO'
}

export enum ValmistumispyynnonHyvaksyjaRole {
  VASTUUHENKILO_OSAAMISEN_ARVIOIJA = 'VASTUUHENKILO_OSAAMISEN_ARVIOIJA',
  VASTUUHENKILO_HYVAKSYJA = 'VASTUUHENKILO_HYVAKSYJA',
  VASTUUHENKILO_OSAAMISEN_ARVIOIJA_HYVAKSYJA = 'VASTUUHENKILO_OSAAMISEN_ARVIOIJA_HYVAKSYJA',
  VIRKAILIJA = 'VIRKAILIJA'
}
